import * as React from "react";
import { userManager } from '../services/sso';

const SilentCallbackPage: React.FC = () => {

  React.useEffect(() => {
    userManager.signinSilentCallback().catch(err => console.log(err));
  }, []);

  return (
    <div/>
  );
};

export default SilentCallbackPage;
